module.exports = __webpack_public_path__ + "static/media/st-3.afeba78b.jpg";